module.exports = __webpack_public_path__ + "img/full.36532457.png";